import { createValidation } from '../../../utils/validation';
export const createComplaintActionTakenTypeValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintActionTakenTypeData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintActionTakenTypeValidation;

